import { Component } from 'react';
import { MotionConfig } from 'framer-motion';
import '@/App.css';
import { LanguageProvider } from '@/i18n/LanguageContext';
import useSmoothScroll from '@/hooks/useSmoothScroll';
import Nav from '@/components/Nav';
import Marquee from '@/components/Marquee';
import Opening from '@/sections/Opening';
import Verbs from '@/sections/Verbs';
import Why from '@/sections/Why';
import Situations from '@/sections/Situations';
import WhatWeDo from '@/sections/WhatWeDo';
import SituationGame from '@/sections/SituationGame';
import Videos from '@/sections/Videos';
import About from '@/sections/About';
import Rooms from '@/sections/Rooms';
import Contact from '@/sections/Contact';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

function Site() {
  useSmoothScroll();
  return (
    <>
      <a
        href="#what-i-do"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[70] focus:bg-[var(--pz-green)] focus:px-4 focus:py-2 focus:text-black"
      >
        Salta al contenuto
      </a>
      <div className="bg-pattern" style={{ backgroundImage: "url('/assets/pattern-black.webp')" }} aria-hidden="true" />
      <Nav />
      <main>
        <Opening />
        <Verbs />
        <Why />
        <Situations />
        <WhatWeDo />
        <SituationGame />
        <Videos />
        <About />
        <Rooms />
        <Marquee />
        <Contact />
      </main>
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <MotionConfig reducedMotion="user">
        <ErrorBoundary>
          <Site />
        </ErrorBoundary>
      </MotionConfig>
    </LanguageProvider>
  );
}
